import { IoChevronForward, IoLocationOutline } from "react-icons/io5";
/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Post } from '../compornents/Post';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { toast } from 'react-toastify';
import { Analytics } from '../compornents/Analytics';
import OrderStatus from '../compornents/OrderStatus';
import {Badge,PLACEMENT, SHAPE, COLOR } from "baseui/badge";


export const Orders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  // 注文選択
  const selectOrder = (order) => {
    // スタッフ訪問(otype=13)はロッカー・配達の流れが無いので、専用の状況画面へ（2026-09-11）
    if (Number(order.otype) === 13) { navigate('/staff_visit?order=' + order.id); return; }
    navigate("/order/" + order.id,{state:{order:order}});
  };
  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });

  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    // 注文情報取得
    async function getOrders() {
      openLoadingModal();
      const request_data = {}
      // post
      const response_data = await Post('post', '/order/index.php', request_data);
      // 結果
      // console.log(response_data);
      if (response_data.result === 1) {
        setOrders(response_data.orders);
      } else {
        // エラー
        toast.error(response_data.error_message);
      }
      closeLoadingModal();
    }
    getOrders();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // console.log(orders.length);
  const listOrders = orders.length > 0 ? orders.map(order =>
    <Badge content={order.new_comment_qty}
      horizontalOffset="0"
      placement={PLACEMENT.topRightEdge}
      shape={SHAPE.pill}
      color={COLOR.negative}
      hidden={!Number(order.new_comment_qty)}
      key={order.id}>
      <div className="order div_btn mb-2" onClick={() => selectOrder(order)}>
        <div className="order_content ">
          <div className="order_header">
            <OrderStatus
              order={order}
            />
            <div className="order_date">
              ・{order.order_date}
            </div>
          </div>
          <div className="order_item mb-3">
            {order.item_name}
          </div>
          {/* <div className="order_user_info mb-3">
            <div className="order_pin mr-1">
              <IoLocationOutline />
            </div>
            <div className="order_address">
              { order.pref + order.add1 + order.add2 }<br/>
              { order.add3 }{ order.room }
            </div>
          </div> */}
        </div>
        <div className="order_arrow">
          <IoChevronForward />
        </div>
      </div>
    </Badge>
  ) : (<div>ご注文はありません</div>);
  return (
      <div className="App">
        <div className="Orders">
          <Analytics title="注文履歴" />
          <div className="mt-3 mb-5">
            <div className="h3 mt-4 mb-4 text-left">
              注文履歴
            </div>
            <div className="">
              {listOrders}
            </div>
          </div>
          <LoadingModal>
            <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
              <button onClick={closeLoadingModal} className="hide">閉じる</button>
              <div >
                <TailSpin stroke="#000" />
              </div>
              <div className="">
                <div className="">
                  処理中です
                </div>
              </div>
            </div>
          </LoadingModal>
        </div>
        <Tabbar menu="orders" />
      </div>
  );
}
